@if (getUrl()) {
  @if (needBtn()) {
    <button
      class="btn"
      (click)="handleClick()"
    >
      <img
        class="file-img"
        alt=""
        width="80"
        height="80"
        [src]="getUrl()"
        [style.width]="imgSize().width"
        [style.height]="imgSize().height"
      >
    </button>
  } @else {
    <div class="file-img-wrapper">
      <img
        class="file-img"
        alt=""
        [src]="getUrl()"
        width="80"
        height="80"
        [style.width]="imgSize().width"
        [style.max-height]="imgSize().height"
      >
    </div>
  }
} @else {
  <div
    class="skeleton-loader file-img"
    [style.width]="imgSize().width"
    [style.height]="imgSize().height"
  ></div>
}
